import { Component, ErrorInfo, ReactNode } from 'react'

import { ServerErrorPage } from 'pages/system/ServerErrorPage'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

/** Catches render-time crashes anywhere below it and shows the 500 page instead of a blank screen. */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Unhandled render error', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) return <ServerErrorPage />
    return this.props.children
  }
}
